/**
 * Every route in one place, as functions rather than string literals scattered
 * through the screens. A slug change is then a single edit.
 */
export const routes = {
  platform: {
    overview: () => '/',
    businesses: () => '/businesses',
    business: (slug: string) => `/businesses/${slug}`,
    businessBook: (slug: string) => `/businesses/${slug}/book`,
    plans: () => '/plans',
    subscriptions: () => '/subscriptions',
    usage: () => '/usage',
    health: () => '/health',
    support: () => '/support',
    accessLog: () => '/access-log',
    settings: () => '/settings',
  },
  owner: {
    overview: () => '/admin',
    people: () => '/admin/people',
    newPerson: () => '/admin/people/new',
    history: () => '/admin/history',
    backup: () => '/admin/backup',
    settings: () => '/admin/settings',
  },
} as const
